export const getGoogleFontUrl = (fontFamily: string) => {
  const combinedString = getGoogleFontQuery(fontFamily);

  return `https://fonts.googleapis.com/css2?${combinedString}&display=swap`;
};

export const getGoogleFontQuery = (fontFamily: string) => {
  return fontFamily
    .split(",")
    .map((font) => font.trim().replaceAll(/'/g, ""))
    .filter((font) => supportedFonts.has(font))
    .reduce(
      (prev, font, i) =>
        prev +
        (i ? "&" : "") +
        "family=" +
        font.replaceAll(/ /g, "+") +
        ":wght@400;500;600",
      ""
    );
};

// List of supported fonts in Commerce Center
// See: frontend/apps/checkout-settings/src/config/fonts.ts
const supportedFonts = new Set([
  "Be Vietnam Pro",
  "Bitter",
  "Chakra Petch",
  "Hahmlet",
  "Inconsolata",
  "Inter",
  "Lato",
  "Lora",
  "M PLUS 1 Code",
  "Montserrat",
  "Noto Sans JP",
  "Noto Sans",
  "Noto Serif",
  "Nunito",
  "Open Sans",
  "Pridi",
  "PT Sans",
  "PT Serif",
  "Raleway",
  "Roboto",
  "Roboto Slab",
  "Source Sans 3",
  "Titillium Web",
  "Ubuntu Mono",
  "Zen Maru Gothic",
]);
